<template>
  <div class="-image" @click="previewAsset">
    <div class="-inner">
      <img
        v-if="!imageError"
        :src="mixinSrc(src)"
        @error="onImageError"
        :draggable="false"
      />
      <div v-else class="-error">
        <span class="wticon wticon-picture-sun" />
      </div>
      <template v-if="showActions && !overlay">
        <wt-asset-locate @locate="$emit('locate')" :asset="asset" />
        <wt-asset-remove @remove="$emit('remove')" />
        <wt-asset-add :disabled="!canAdd" @add="$emit('add')" />
      </template>
    </div>

    <div v-if="!overlay" class="-indicators">
      <transition name="wt2-fade-fast">
        <wt-asset-used v-if="isUsed" />
      </transition>
    </div>

    <wt-asset-icons-overlay-asset
      v-if="overlay"
      :duration="displayDuration"
      :icons="iconsForOverlayAsset"
    />
    <wt-asset-icons v-else :restrictions="assetRestrictions" :icons="icons" />
  </div>
</template>
<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetIconsForOverlayAsset from 'components/assets/mixins/AssetIconsForOverlayAsset.vue';
import AssetIcons from 'components/assets/mixins/AssetIcons.vue';

export default {
  mixins: [AssetMixins],
  components: {
    'wt-asset-icons-overlay-asset': AssetIconsForOverlayAsset,
    'wt-asset-icons': AssetIcons,
  },

  computed: {
    src: function () {
      return (
        (this.asset && this.asset.metadata && this.asset.metadata.url) || null
      );
    },
  },
};
</script>
